import * as React from 'react';

import Icon from 'components/icon/icon';

type BadgeProps = {
  index: number;
  text: string;
};

const badgeIconList = [
  Icon.Name.EditFill,
  Icon.Name.PronounsFill,
  Icon.Name.GenderFIll,
  Icon.Name.MapPinFill,
  Icon.Name.MailFill,
  Icon.Name.CameraFill,
  Icon.Name.ClockFill,
  Icon.Name.PhoneFill,
  Icon.Name.PronounsFill,
  Icon.Name.HeartFill,
];

export const Badge = (props: BadgeProps) => {
  const iconName = badgeIconList[props.index];

  return (
    <span className="badge">
      <span className="badge__content">
        {iconName && (
          <span className="badge__icon">
            <Icon name={iconName} size="xsm" />
          </span>
        )}
        <span className="badge__text">{props.text}</span>
      </span>
    </span>
  );
};
